import * as type from './type'
import {post} from "../../../../util/api";
import {findImageVersionSuccess} from "../image/action";

export const setSelectedImageVersions = (preCheckinPhotoIndex, imageVersionIndexInGallery) => ({
    type: type.SET_SELECTED_IMAGE_VERSIONS,
    payload: {
        selectedImageVersions: [
            {
                preCheckinPhotoIndex: preCheckinPhotoIndex,
                imageVersionIndexInGallery: imageVersionIndexInGallery,
            }
        ]
    },
})

export const setPhotoRejectionReason = (imageVersion, reason) => (dispatch, getState) => {
    post('/api/customer/set-image-reason-meta-data', {
        customerId: imageVersion.customerId,
        path: imageVersion.path,
        versionId: imageVersion.versionId,
        reason: reason,
    }).then((imageVersionList) => {
        dispatch(findImageVersionSuccess(imageVersionList))
    })

    return {
        type: type.SET_NEW_PHOTOS_NEEDED_REASON,
        payload: [
            {
                versionId: imageVersion.versionId,
                reason: reason,
            }
        ]
    }
}



// WEBPACK FOOTER //
// ./src/modules/customer/state/task-widget/action.js